import { render, staticRenderFns } from "./TerminateEmployeeModal.vue?vue&type=template&id=665db1e8&scoped=true"
import script from "./TerminateEmployeeModal.vue?vue&type=script&lang=js"
export * from "./TerminateEmployeeModal.vue?vue&type=script&lang=js"
import style0 from "./TerminateEmployeeModal.vue?vue&type=style&index=0&id=665db1e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665db1e8",
  null
  
)

export default component.exports